import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

function initializeRoutePlannerMap(
    mapElement
) {
    if (
        mapElement.dataset
            .routePlannerMapReady
        === 'true'
    ) {
        return;
    }

    const dataElement =
        mapElement.querySelector(
            '[data-route-planner-result]'
        );

    if (!dataElement) {
        return;
    }

    let route;

    try {
        route = JSON.parse(
            dataElement.textContent
            || '{}'
        );
    } catch {
        return;
    }

    const geometry =
        Array.isArray(route.geometry)
            ? route.geometry
            : [];

    if (geometry.length === 0) {
        return;
    }

    mapElement.dataset.routePlannerMapReady =
        'true';

    const map = L.map(
        mapElement,
        {
            zoomControl: true,
            scrollWheelZoom: false,
        }
    );

    L.tileLayer(
        'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        {
            maxZoom: 20,
            attribution:
                '&copy; OpenStreetMap contributors',
        }
    ).addTo(map);

    const latLngs = geometry
        .map((point) => {
            const latitude =
                Number.parseFloat(
                    point.latitude
                );

            const longitude =
                Number.parseFloat(
                    point.longitude
                );

            if (
                !Number.isFinite(latitude)
                || !Number.isFinite(longitude)
            ) {
                return null;
            }

            return [
                latitude,
                longitude,
            ];
        })
        .filter(Boolean);

    if (latLngs.length === 0) {
        return;
    }

    const routeLine = L.polyline(
        latLngs,
        {
            color: '#2563eb',
            weight: 7,
            opacity: 0.9,
        }
    ).addTo(map);

    const junctions =
        Array.isArray(
            route.junctions
        )
            ? route.junctions
            : [];

    junctions.forEach(
        (junction) => {
            const latitude =
                Number.parseFloat(
                    junction.latitude
                );

            const longitude =
                Number.parseFloat(
                    junction.longitude
                );

            if (
                !Number.isFinite(latitude)
                || !Number.isFinite(longitude)
            ) {
                return;
            }

            L.circleMarker(
                [
                    latitude,
                    longitude,
                ],
                {
                    radius: 5,
                    color: '#4338ca',
                    weight: 2,
                    fillColor: '#6366f1',
                    fillOpacity: 1,
                }
            )
                .addTo(map)
                .bindTooltip(
                    junction.name
                    || 'Junction',
                    {
                        direction: 'top',
                    }
                );
        }
    );

    const endpointMarker = (
        endpoint,
        isStart
    ) => {
        if (!endpoint) {
            return;
        }

        const latitude =
            Number.parseFloat(
                endpoint.latitude
            );

        const longitude =
            Number.parseFloat(
                endpoint.longitude
            );

        if (
            !Number.isFinite(latitude)
            || !Number.isFinite(longitude)
        ) {
            return;
        }

        const marker =
            L.circleMarker(
                [
                    latitude,
                    longitude,
                ],
                {
                    radius: 9,
                    color:
                        isStart
                            ? '#15803d'
                            : '#b91c1c',
                    weight: 3,
                    fillColor:
                        isStart
                            ? '#22c55e'
                            : '#ef4444',
                    fillOpacity: 1,
                }
            ).addTo(map);

        marker.bindTooltip(
            `${
                isStart
                    ? 'Start: '
                    : 'Destination: '
            }${endpoint.name || ''}`,
            {
                permanent: true,
                direction: 'top',
            }
        );
    };

    endpointMarker(
        route.from_endpoint,
        true
    );

    endpointMarker(
        route.to_endpoint,
        false
    );

    map.fitBounds(
        routeLine.getBounds(),
        {
            padding: [50, 50],
            maxZoom: 18,
            animate: false,
        }
    );

    window.setTimeout(
        () => map.invalidateSize(),
        100
    );
}

function initializeAll() {
    document
        .querySelectorAll(
            '[data-route-planner-map]'
        )
        .forEach(
            initializeRoutePlannerMap
        );
}

if (
    document.readyState
    === 'loading'
) {
    document.addEventListener(
        'DOMContentLoaded',
        initializeAll,
        {
            once: true,
        }
    );
} else {
    initializeAll();
}

document.addEventListener(
    'livewire:navigated',
    initializeAll
);
